module.exports = __webpack_public_path__ + "static/pos-925f73f3a51165374b898d81aef1f7cb.png";